/*
 * @Description:
 * @Author: ywj
 * @Date: 2025-03-10 15:07:07
 * @LastEditTime: 2025-08-06 17:00:18
 * @LastEditors: taoyuan taoyuan@originqc.com
 */
import request from '@/utils/request';

/** 获取省、市、区列表*/
export const getAreaList = (data: any) =>
  request({
    url: `accountCenter/address/getAreaList.json`,
    method: 'post',
    data,
  });

/** 获取地址树 */
export const getTree = (data: any) =>
  request({
    url: `accountCenter/address/getTree.json`,
    method: 'post',
    data,
  });

/** 新增收货地址 */
export const addAddress = (data: any) =>
  request({
    url: `accountCenter/address/add.json`,
    method: 'post',
    data,
  });

/** 编辑收货地址 */
export const editAddress = (data: any) =>
  request({
    url: `accountCenter/address/edit.json`,
    method: 'post',
    data,
  });

/** 删除地址 */
export const deleteAddress = (id: string) =>
  request({
    url: `accountCenter/address/delete.json/${id}`,
    method: 'post',
  });

/** 设置默认收货地址 */
export const setDefaultAddr = (id: string) =>
  request({
    url: `accountCenter/address/setDefaultAddr.json/${id}`,
    method: 'post',
  });

/** 获取用户的收货地址列表 */
export const addressList = () =>
  request({
    url: `accountCenter/address/list.json`,
  });

/** 获取单个地址详情 */
export const getAddressDetail = (id: string) =>
  request({
    url: `accountCenter/address/getOne.json/${id}`,
  });

/** 订单列表 */
export const getOrderList = (data?: any) =>
  request({
    url: `orderCenter/order/getOrderList.json`,
    method: 'post',
    data,
  });
// 删除订单
export const deleteOrderList = (id: string) =>
  request({
    url: `orderCenter/order/deleteOrderById.json/${id}`,
    method: 'post',
  });
// 取消订单
export const cancelOrder = (id: string, data: any) =>
  request({
    url: `orderCenter/order/cancel.json/${id}`,
    method: 'post',
    data,
  });
// 确认收货
export const confirmReceipt = (id: string) =>
  request({
    url: `orderCenter/order/accept.json/${id}`,
    method: 'post',
  });
// 订单进度
export const processDetail = (id: string) =>
  request({
    url: `orderCenter/order/getOprHistory.json?orderId=${id}`,
  });
// 订单统计
export const orderCountTotal = () =>
  request({
    url: `/orderCenter/order/getOrderStats.json`,
  });

/************  开票信息 ************/
// 开票列表
export const getBillBaseList = () =>
  request({
    url: `accountCenter/billBase/list.json`,
  });

//设置默认值
export const setDefaultBill = (id: number) =>
  request({
    url: `accountCenter/billBase/setDefaultBill.json/${id}`,
    method: 'post',
  });

//删除发票
export const deleteBill = (id: number) =>
  request({
    url: `accountCenter/billBase/delete.json/${id}`,
    method: 'post',
  });

// 新增
export const addBill = (data: any) =>
  request({
    url: `accountCenter/billBase/add.json`,
    method: 'post',
    data,
  });

//修改
export const editBill = (data: any) =>
  request({
    url: `accountCenter/billBase/edit.json`,
    method: 'post',
    data,
  });

/***********订单支付 ****************/
// 获取支付二维码
export const createOrder = (data: any) =>
  request({
    url: `orderCenter/order/createOrder.json`,
    method: 'post',
    data,
  });

// 查询扫码支付结果
export const getPayResult = (orderNo: string) =>
  request({
    url: `orderCenter/order/getPayResult.json?orderNo=${orderNo}`,
  });

export const transferable = (orderId: number) =>
  request({
    url: `orderCenter/order/transferable.json/${orderId}`,
    method: 'post',
  });
/** 获取单个详情 */
export const getOrderById = (params: any) =>
  request({
    url: `orderCenter/order/getOrderById.json`,
    params,
  });
/** 获取用户配置的基础发票信息 */
export const getUserBillBaseList = () =>
  request({
    url: `accountCenter/billBase/list.json`,
  });
/** 购物车列表 */
export const getShoppingCartList = () =>
  request({
    url: `orderCenter/cart/getCartInfo.json`,
  });

// 获取购物车暂存数据
export const getTempDate = () =>
  request({
    url: `orderCenter/cart/getTempDate.json`,
  });

// 获取验证码
export const getCode = (data: { email?: string; tel?: string }) =>
  request({
    url: `orderCenter/activation/code.json`,
    method: 'post',
    data,
  });

// 获取激活码
export const getActivation = (data: {
  code: string;
  orderId: string;
  email?: string;
  tel?: string;
}) =>
  request({
    url: `orderCenter/activation/getActivation.json`,
    method: 'post',
    data,
  });

  // 协议pdf
export const getPdfContent = () =>
request({
  url: `product/page/config.json?type=2 `,
});
